<template>
    <div>
        <!-- snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- overlay -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin -->
        <v-card class="box v-card" v-if="ay_std_data != null">
            <v-toolbar flat dense class="toolbar no-display">
                <v-toolbar-title>Academic Data</v-toolbar-title>
            </v-toolbar>
                <v-row justify="center" class="no-display" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense required v-model="current_academic_year" :items="ay_std_data.academic_year_list" item-text="Academic Year" label="Academic Year" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense v-model="std" multiple :items="ay_std_data.standard_list" item-text="standard" label="Standard" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="status" :items="ay_std_data.status_list" item-text="name" label="Status" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-btn class="mt-6 button" @click="getAcademicData">Fetch</v-btn>
                    </v-col>
                </v-row>
                <!-- {{ data_list }} -->
                 <v-btn rounded class="button mt-6 no-display" @click="print()" v-if="data_list!=''">Print</v-btn><br>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="6" md="6">
                <v-simple-table class="table" v-if="data_list!=''">
                    <tbody>
                        <tr v-for="(obj,i) in data_list" :key="i">
                            <v-simple-table class="table elevation-1" dense>
                                <thead>
                                    <th class="text-center" colspan="3">{{ obj.std_div }}</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <th>Boys</th>
                                        <th>Girls</th>
                                    </tr>

                                    <tr v-for="(row, j) in cat_name" :key="j">
                                        <th bgcolor="yellow" v-if="row=='Total'">{{ row}}</th>
                                        <td bgcolor="yellow"  v-else>{{ row}}</td>
                                        <td>{{ obj.cat_data[row]["Male"] }}</td>
                                        <td>{{ obj.cat_data[row]["Female"] }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-center toolbar" colspan="3">Minority (included in General(Open))</th>
                                    </tr>
                                    <tr v-for="(row, j) in rel_name" :key="j">
                                        <th bgcolor="yellow"  v-if="row=='Total'">{{ row}}</th>
                                        <td  bgcolor="yellow"  v-else>{{ row }}</td>
                                        <td>{{ obj.rel_data[row]["Male"] }}</td>
                                        <td>{{ obj.rel_data[row]["Female"] }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </tr>
                    </tbody>
                </v-simple-table>
                </v-col>
                </v-row>
        </v-card>
        <br />
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            ///////////////////////////////////////////////
            ay_std_data: null,
            current_academic_year: null,
            std: [],
            status_list: null,
            status: null,
            data_list: [],
            cat_name: [],
            rel_name: [],
        }),
        methods: {
             print(){
                   this.$store.state.drawer = false;
                    let that = this;
                    window.onafterprint = function () {
                        that.$store.state.drawer = true;
                    };
                    setTimeout(function () {
                        window.print();
                    }, 100);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            ///////////
            async getAcademicData() {
                console.log(this.status);
                console.log(this.current_academic_year);
                console.log(this.std);
                if (this.std.length == 0) {
                    alert("Please select standard");
                    return;
                }
                const formdata = {
                    status: this.status.id,
                    current_academic_year: this.current_academic_year,
                    std: this.std,
                    cat_name: this.cat_name,
                    rel_name: this.rel_name,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/admission/getAcademicData", formdata);
                    if (res.data.flag == "YES") {
                        this.data_list = res.data.data_list;
                    } else {
                        //error
                        this.showSnackbar("red", res.data.snackbar);
                    }

                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    console.log("bye...");
                    this.overlay = false;
                }
            },
            async init() {
                this.overlay = true;
                try {
                    const res = await axios.post("/feesMaster/get_ay_std_ft");
                    if (res.data.msg == "200") {
                        this.ay_std_data = res.data.fees_structure_data;
                        this.current_academic_year = res.data.fees_structure_data.current_academic_year;
                        //this.std = this.ay_std_data.standard_list[0];
                        this.status_list = res.data.status_list;
                        this.status = this.status_list[1];
                    } else {
                        //error
                        this.showSnackbar("red", res.data.snackbar);
                    }

                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    console.log("bye...");
                    this.overlay = false;
                }
            },
        },
        mounted() {
            this.cat_name = ["OPEN", "SC", "ST", "OBC", "NT", "Others", "Total"];
            this.rel_name = ["Muslim", "Christian", "Jain", "Nav Bouddha", "Parsi", "Total"];
            this.init();
        },
    };
</script>
<style>
    .table {
        cellpadding: 0px;
        cellspacing: 0px;
    }
    thead {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        /* font-size: small; */
    }
    tr,
    tbody {
        /* border-bottom: 1px solid black; */
        border: 1px solid black;
        /* font-size: small; */
    }
    /* td {
        font-size: small;
    } */
    .msg {
        font-weight: Normal !important;
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    @media print {
            @page {
                size: A4  !important;
                margin-top: none !important;
                padding-top: none !important;
                /* size: 400mm 100mm; */
            }
            .no-display,
            .v-input__control,
            input[type="button"],
            input[type="submit"],
            input[type="reset"],
            #v-card {
                display: none !important;
            }
           .v-card {
                border: none !important;
            }
        }
</style>
